import { render } from "./BlocklistItem.vue?vue&type=template&id=77d63bb8&ts=true"
import script from "./BlocklistItem.vue?vue&type=script&lang=ts"
export * from "./BlocklistItem.vue?vue&type=script&lang=ts"

import "./BlocklistItem.vue?vue&type=style&index=0&id=77d63bb8&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__